import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import {DQC_TIMEOUT} from './core/globals';

@NgModule({
    providers:[
        {
            provide:DQC_TIMEOUT,
            useValue:environment.dqc.timeout
        }
    ]
})
export class DQCConfigModule { }

